import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Ready from '../views/Ready.vue'
import Instructions from '../views/Instructions.vue'
import Instructions2 from '../views/Instructions2.vue'
import Instructions3 from '../views/Instructions3.vue'
import SpotTheNot from '../views/SpotTheNot.vue'
import Final from '../views/Final.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/ready',
    name: 'ready',
    component: Ready
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: Instructions
  },
  {
    path: '/instructions-2',
    name: 'instructions2',
    component: Instructions2
  },
  {
    path: '/instructions-3',
    name: 'instructions3',
    component: Instructions3
  },
  {
    path: '/spot-the-not',
    name: 'spotthenot',
    component: SpotTheNot
  },
  {
    path: '/final',
    name: 'final',
    component: Final
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router